module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f0751c_banner_800x600.d04aad44.png";